import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Link } from 'react-router-dom';


export default function NilaiKTSPTable(props) {
  const { onFormChange, form } = props;
  return (
    <div className="tbm__content">
      <div className="tbm__body">
        <table className="tbm__table">
          <thead>
            <tr>
              <th rowSpan={2}>No/NIS</th>
              <th rowSpan={2}>Nama</th>
              <th rowSpan={2}>Guru</th>
              <th colSpan={5}>Ulangan/Quiz</th>
              <th rowSpan={2}>UH</th>
              <th colSpan={3}>Tugas</th>
              <th rowSpan={2}>NH</th>
              <th colSpan={9}>Kesimpulan</th>
            </tr>
            <tr>
              <th>UH 1</th>
              <th>UH 2</th>
              <th>UH 3</th>
              <th>UH 4</th>
              <th>UH 5</th>

              <th>Tugas 1</th>
              <th>Tugas 2</th>
              <th>Tugas 3</th>

              <th>PTS 1</th>
              <th>PAS 2</th>
              <th>RNH</th>
              <th>RPR</th>
              <th>NRA</th>
              <th>R1</th>
              <th>NRA</th>
              <th>NRN</th>
              <th>Comment/Deskripsi</th>

            </tr>

          </thead>
          <tbody>
            {/* {
                      map(journal.details, (list, idx) => (
                        <tr key={`journal_detail_${idx}`}>
                          <td>{idx + 1}</td>
                          <td>{list.code_of_account}</td>
                          <td>{list.parameter_code.title}</td>
                          <td>{list.description}</td>
                          <td className="nominal">{commaFormatted(list.amount)}</td>
                        </tr>
                      ))
                    } */}
            {/* <tr>
                        <td>1</td>
                        <td>aa</td>
                        <td>122</td>
                        <td><Select
                            name="workflow"
                            onChange={onFormChange}
                            data={ 'Hadir', 'hadir'}
                            placeholder={'Hadir'}


                        // error={form.error.namaSaudara1 || ''}
                            /></td>


                    </tr> */}
            <tr>
              <td colSpan="1" rowSpan="2">344444</td>
              <td colSpan="1" rowSpan="2">Banana</td>
              <td colSpan="1" rowSpan="2">Guru Mapel</td>
              <td><Link to="/dashboard/kurikulum/laporan/daftar-nilai-siswa">90</Link></td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td colSpan="1" rowSpan="2">siswa sangat mampu dll</td>
            </tr>
            <tr>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
            </tr>


          </tbody>
          {/* <tfoot>
                      <tr>
                        <td colSpan="1" className="nominal">Catatan Wali Kelas</td>
                        <td colSpan="8" className="nominal"></td>
                      </tr>
                    </tfoot> */}
        </table>
      </div>
    </div>
  );
}
NilaiKTSPTable.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
NilaiKTSPTable.defaultProps = {
  onFormChange: noop,
};
